import {createUseStyles} from "react-jss";
import PercentageBar from "../PercentageBar/PercentageBar";

export const useStyles = createUseStyles({
    item: {

        "& + &": {
            marginTop: 20,
        }

    }
});